// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import SelectNetworkForDisplayPathModifiers from '../app/select-network-for-display-path-modifiers';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Network',
                        component: SelectNetworkForDisplayPathModifiers,
                    },
                ],
            },
        ],
    },
};

function DashboardSelectNetworkForDisplayPathModifiers() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="dashboardSelectNetworkForDisplayPathModifiers"
            version="1"
        />
    );
}

export default DashboardSelectNetworkForDisplayPathModifiers;
